import { combineReducers } from 'redux';
import { accessControlReducer } from './accessControl/reducers';
import { appReducer } from './app/reducers';
import permissionsReducer from './auth/reducers';
import authReducer from './authentication/reducers';
import { campaignReducer } from './campaign/reducers';
import conversationsReducer from './conversations/reducers';
import couponsReducers from './coupons/reducers';
import credentialsReducer from './credentials/reducers';
import facebookMessageReducer from './facebook/facebookMessageReducer';
import facebookPostReducer from './facebook/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import headerSearchReducerV2 from './headerSearchV2/reducer';
import systemInstructionReducer from './instructions/reducers';
import { knowledgebaseReducer } from './knowledgebase/reducers';
import { readMessageReducer } from './message/reducers';
import conversationsMessagesReducer from './messages/reducers';
import { readNotificationReducer } from './notification/reducers';
import { productOrderReducer } from './order/reducers';
import { outboundCallReducer } from './outboundCallCampaign/reducers';
import { packageReducer } from './packages/reducers';
import { paymentReducer } from './payment/reducers';
import { productReducer } from './products/reducers';
import searchFilterReducer from './serach/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import ticketReducer from './tickets/reducers';
import usersReducer from './users/reducers';
import userDetailsReducer from './users/userDetails/reducer';

const rootReducers = combineReducers({
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  auth: authReducer,
  apps: appReducer,
  ChangeLayoutMode,
  accessControl: accessControlReducer,
  permissions: permissionsReducer,
  conversations: conversationsReducer,
  users: usersReducer,
  userDetails: userDetailsReducer,
  order: productOrderReducer,
  packages: packageReducer,
  payments: paymentReducer,
  coupons: couponsReducers,
  messages: conversationsMessagesReducer,
  searchFilterReducer,
  credentials: credentialsReducer,
  posts: facebookPostReducer,
  campaigns: campaignReducer,
  knowledgebase: knowledgebaseReducer,
  product: productReducer,
  facebookMessages: facebookMessageReducer,
  outbound: outboundCallReducer,
  tickets: ticketReducer,
  systemInstruction: systemInstructionReducer,
  headerSearch: headerSearchReducerV2,
});

export default rootReducers;
